import React from "react";
import styles from "./listAssetCard.module.scss";
import DefaultAssetIcon from "../../../../../legacy/images/defaultAsset.jpg";
import { Media } from "../../../../../types/media";
import _ from "lodash";
import cx from "classnames";
import Button from "../../../../../components/button";
import dateFormat from "dateformat";
import { FileService } from "src/utils/file.service";
import Tooltip from "src/components/tooltip/index";
import { useNavigate } from "react-router-dom";
import { NavigateEntity } from "src/components/NavigateEntity";
import Text from "src/components/text";

interface AssetIcon {
  id: string;
  icon?: Media;
  name?: string;
  contentModifiedDate?: Date;
  metadata?: any;
  settings? : boolean
}

export function ListAssetCard({
  id,
  icon,
  name,
  contentModifiedDate,
  metadata,
  settings
}: AssetIcon) {
  const navigate = useNavigate();
  const internal = !_.get(settings, 'share', false);
  
  return (
    <div key={id} className={styles.listAssetCard}>
      <div className={styles.assetIcon}>
        {internal && 
        <div className={styles.indicators}>
          <Tooltip content={'Internal use only'} placement='top'>
            <i className="paperflite-lock"></i>
          </Tooltip>
        </div>
      }
      
        <NavigateEntity
          path={`/assets/${id}`}
          className={styles.link}
          onClick={()=> {
            navigate(`/assets/${id}`)
          }}
        >
          <img
            src={icon?.thumbnail != null ? icon.thumbnail : DefaultAssetIcon}
            className={styles.thumbnail}
            alt="asset thumbnail"
          />
        </NavigateEntity>
      </div>
      <p className={styles.assetDetails}>
        <span className={styles.fileType}>
          {FileService.getFileType(metadata)}
        </span>
        <span className={styles.assetName}>
          <Text text={name} lines={1} />
        </span>
        <p className={styles.modifiedDate}>
          Updated on {dateFormat(contentModifiedDate, "dd mmm yyyy")}
        </p>
        <NavigateEntity
          path={`/assets/${id}`}
          className={styles.link}
          onClick={()=> {
            navigate(`/assets/${id}`)
          }}
        >
          <Button
            text="explore"
            variant="tertiary"
            icon="paperflite-right-arrow"
          />
        </NavigateEntity>
      </p>
    </div>
  );
}

export function ListPlaceholderAssetCard() {
  return (
    <div className={cx(styles.listAssetCard, styles.placeholder)}>
      <div className={cx(styles.assetIcon, styles.block)}></div>
      <p className={cx(styles.assetName, styles.block)}></p>
      <span className={cx(styles.explore, styles.block)}></span>
    </div>
  );
}
